module.exports = __webpack_public_path__ + "static/interconnectivity-ea53c1b44960553afb60571605c3e8b2.svg";